import { useEffect, useState } from 'react';
import { CompDivisionDrawsDTO } from './comp.type';
import { ProjectDraw } from '../project/project.type';
import { handleError } from '../../common/utils/util.errors';
import { getDivisionDraws } from './comp.api';

interface SelectedProjectDraws {
  [divisionId: string]: string[];
}
const useCompDivisionDraws = (compId: string) => {
  const [selectedProjectDraws, setSelectedProjectDraws] = useState<SelectedProjectDraws>({});

  const handleProjectDrawSelectionChange = (divisionId: string, newSelectedProjectDraws: string[]) => {
    setSelectedProjectDraws({ ...selectedProjectDraws, [divisionId]: newSelectedProjectDraws });
    ``;
  };

  useEffect(() => {
    getDivisionDraws(compId)
      .then((response: CompDivisionDrawsDTO) => {
        const initialSelectedProjectDraws: SelectedProjectDraws = {};

        for (const divisionId in response) {
          initialSelectedProjectDraws[divisionId] = response[divisionId].map((draw: ProjectDraw) => draw.id);
        }

        setSelectedProjectDraws(initialSelectedProjectDraws);
      })
      .catch(error => {
        handleError('Error fetching division draws!');
        console.error('Error fetching division draws:', error);
      });
  }, [compId]);

  return { selectedProjectDraws, handleProjectDrawSelectionChange };
};

export default useCompDivisionDraws;
